module.exports = __webpack_public_path__ + "static/media/sine.30e19286.svg";